// extracted by mini-css-extract-plugin
var _1 = "ModalPrimitive-module__animateUploadProgressBarWidth--K5otN";
var _2 = "ModalPrimitive-module__animatedBackground--mkSVf";
var _3 = "ModalPrimitive-module__closeContainer--ildm7";
var _4 = "ModalPrimitive-module__description--BXwIX";
var _5 = "ModalPrimitive-module__footer--Hrk8a";
var _6 = "ModalPrimitive-module__fullscreen--k7YWZ";
var _7 = "ModalPrimitive-module__right--hasBJ";
var _8 = "ModalPrimitive-module__root--zmmIf";
var _9 = "ModalPrimitive-module__title--ANDaA";
var _a = "ModalPrimitive-module__titleText--mgJiA";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "closeContainer", _4 as "description", _5 as "footer", _6 as "fullscreen", _7 as "right", _8 as "root", _9 as "title", _a as "titleText" }
